// Centralized client-side access helper — mirrors backend core/access.py.
const RANK = { own: 1, managed: 2, tenant: 3, global: 4 };

export function effectiveScope(user, resource, action) {
  const perms = user?.permissions || [];
  if (perms.includes("*")) return "global";
  let best = null;
  for (const s of ["own", "managed", "tenant", "global"]) {
    if (perms.includes(`${resource}.${action}.${s}`) && (!best || RANK[s] > RANK[best])) best = s;
  }
  if (!best && perms.includes(`${resource}.${action}`)) return "tenant";
  return best;
}

export const can = (user, resource, action) => effectiveScope(user, resource, action) != null;
export const isGlobal = (user, resource, action) => effectiveScope(user, resource, action) === "global";
